import React, {useEffect, useRef, useState} from "react";
import Tooltip from "@mui/material/Tooltip";

export const EllipsisCellWithTooltip = ({text}) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setShow(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip title={show ? text : ""} disableHoverListener={!show}>
      <span ref={ref} className="ellipsis-cell">
        {text}
      </span>
    </Tooltip>
  );
}